enum StatusCategories {
  PreBooked,
  InProgress,
  Complete,
  Quote,
  ScheduledTemplate,
  Cancelled
}

export { StatusCategories }
